import React from 'react';
import PropTypes from 'prop-types';
import * as Styles from './index.styles';

const { StyledTab } = Styles;

export const Tab = ({ id, title, onClick, onSelect, disabled, children, ...otherProps }) => {
    return (
        <StyledTab
            id={id}
            onClick={evt => {
                if (!disabled) {
                    onSelect(id);
                }
                onClick(evt);
            }}
            disabled={disabled}
            {...otherProps}
        >
            {title}
        </StyledTab>
    );
};

Tab.propTypes = {
    id: PropTypes.string.isRequired,
    selected: PropTypes.bool,
    disabled: PropTypes.bool,
    title: PropTypes.node.isRequired,
    onClick: PropTypes.func,
    onSelect: PropTypes.func,
    children: PropTypes.node.isRequired,
};

/* istanbul ignore next */
Tab.defaultProps = {
    selected: false,
    disabled: false,
    onClick: () => null,
    onSelect: () => null,
};

Tab.Styles = Styles;
